import { processImage } from 'helpers/utils'

export default ({ errors = null, name, size, uploaded, url, uploadUrl }) => ({
  errors,
  name,
  size,
  uploaded,
  url,
  uploadUrl,

  formatBytes (bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  },

  async upload ({ type, srcElement }) {
    const file = srcElement.files[0]

    if (type !== 'change' || !file) return

    this.$dispatch('upload:start')

    const resizedFile = await processImage(file)

    const resp = await fetch(this.uploadUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: resizedFile
    })

    if (!resp.ok) return

    this.errors = null
    this.url = URL.createObjectURL(file)
    this.name = file.name
    this.size = file.size
    this.uploaded = true
    this.$dispatch('upload:finish')
  }
})
